import { useAtomValue } from 'jotai';
import dynamic from 'next/dynamic';

import type { LinkSessionsToPatientModalProps } from './LinkSessionsToNewPatientModal-implementation';
import { linkSessionsToNewPatientModalOpenAtom } from './LinkSessionsToNewPatientModal.atoms';

const LinkSessionsToPatientModalImplementation = dynamic(
  () =>
    import('./LinkSessionsToNewPatientModal-implementation').then(
      (mod) => mod.LinkSessionsToPatientModalImplementation
    ),
  { ssr: false, loading: () => null }
);

/**
 * Lightweight gate over the create-patient modal. Eight surfaces mount this
 * unconditionally (session rows, the bulk bar, the session header), so while
 * it is closed it must cost nothing: no flag read, no session-list cache read,
 * no dialog chunk. The implementation and its hooks load on first open.
 *
 * Both entry styles still work — a caller either drives `open`/`setOpen`
 * itself or leaves them off and lets `linkSessionsToNewPatientModalOpenAtom`
 * drive it.
 */
const LinkSessionsToPatientModal = (props: LinkSessionsToPatientModalProps) => {
  const atomOpen = useAtomValue(linkSessionsToNewPatientModalOpenAtom);
  const open = props.open !== undefined ? props.open : atomOpen;

  if (!open) {
    return null;
  }

  return <LinkSessionsToPatientModalImplementation {...props} />;
};

export type { LinkSessionsToPatientModalProps };

export default LinkSessionsToPatientModal;
